export default {
    //Loại đặc thù = 0: Không đặc thù | 1: Vũ Thư | 2: đặc thù khác ace thêm sau
    None: 0,
    VuThu: 1
};